import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const InnerBlock = lazy(() =>
  import('./MarkdownBlock').then(m => ({default: m.MarkdownBlock})),
)

export const markdownBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  InnerBlock,
})
